import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TgGridModule } from '@trademe/tangram';
import { Property3DTourSectionModule } from '../../../sections/property-default-sections/property-3d-tour-section/property-3d-tour-section.module';
import { PropertyPhotoSectionModule } from '../../../sections/property-default-sections/property-photo-section/property-photo-section.module';
import { PropertyVideoSectionModule } from '../../../sections/property-default-sections/property-video-section/property-video-section.module';
import { PropertyPhotosPageComponent } from './property-photos-page.component';

@NgModule({
    imports: [
        CommonModule,
        TgGridModule,
        PropertyPhotoSectionModule,
        PropertyVideoSectionModule,
        Property3DTourSectionModule
    ],
    declarations: [PropertyPhotosPageComponent],
    exports: [PropertyPhotosPageComponent]
})
export class PropertyPhotosPageModule {}
